import React from 'react';

export default () => (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
            d="M6.761 0A6.769 6.769 0 0 0 0 6.761a6.769 6.769 0 0 0 6.761 6.761 6.769 6.769 0 0 0 6.761-6.761c0-.761-.133-1.491-.366-2.175l-1.095 1.095a5.414 5.414 0 0 1-5.3 6.489A5.415 5.415 0 0 1 1.352 6.76a5.415 5.415 0 0 1 5.409-5.409c1.104 0 2.131.334 2.988.905l.968-.968A6.72 6.72 0 0 0 6.761 0zm6.283.874-6.96 6.96L3.86 5.606l-.957.956 3.183 3.182L14 1.83l-.956-.956z"
            fill="#00787A" />
    </svg>
);
